<template>
  <component
    :is="asLink ? 'router-link' : 'div'"
    :to="asLink ? to : undefined"
    class="cf-logo"
    :class="[variantClass, { 'cf-logo--clickable': asLink }]"
    :aria-label="ariaLabel"
  >
    <!-- 마크 아이콘 -->
    <img
      class="cf-logo__mark"
      src="@/assets/logo/Union.svg"
      alt=""
      loading="lazy"
      :style="markStyle"
    />
    <!-- 텍스트 로고 (숨길 수 있음) -->
    <img
      v-if="showText"
      class="cf-logo__text"
      src="@/assets/logo/Logo-text.svg"
      alt="CARDIOFACTORY"
      loading="lazy"
      :style="textStyle"
    />
  </component>
</template>

<script>
export default {
  name: "AppLogo",

  props: {
    /**
     * 링크로 쓸지 여부. true면 <router-link> 로 렌더링
     */
    asLink: { type: Boolean, default: false },
    /**
     * asLink=true일 때 이동할 경로
     */
    to: { type: String, default: "/" },
    /**
     * 텍스트 로고 노출 여부 (마크만 쓰고 싶을 땐 false)
     */
    showText: { type: Boolean, default: true },
    /**
     * 크기 프리셋: sm / md / lg
     */
    size: {
      type: String,
      default: "md",
      validator: (v) => ["sm", "md", "lg"].includes(v),
    },
    /**
     * 수동 높이(px). 지정하면 size 프리셋보다 우선
     */
    height: { type: [Number, String], default: null },
    /**
     * 마크와 텍스트 사이 간격(px)
     */
    gap: { type: [Number, String], default: 8 },
    /**
     * 접근성용 라벨(링크일 때 유효)
     */
    ariaLabel: { type: String, default: "Cardio Factory 홈" },
  },

  computed: {
    variantClass() {
      return `cf-logo--${this.size}`;
    },
    markStyle() {
      return {
        height: this.computedHeight + "px",
      };
    },
    textStyle() {
      // 텍스트 로고는 마크 높이에 맞춰 비슷하게
      // 필요하면 배율 살짝 다르게 조정 가능
      return {
        height: Math.round(this.computedHeight * 0.5) + "px",
      };
    },
    computedHeight() {
      if (this.height) return Number(this.height);
      // Figma 기준: 마크 약 22px → 프리셋로 유연화
      switch (this.size) {
        case "sm":
          return 18;
        case "lg":
          return 28;
        case "md":
        default:
          return 22;
      }
    },
  },
};
</script>

<style scoped>
.cf-logo {
  display: inline-flex;
  align-items: center;
  gap: var(--cf-logo-gap, 8px);
  text-decoration: none;
  color: inherit;
}

.cf-logo__mark,
.cf-logo__text {
  display: block;
  width: auto; /* 비율 유지 */
}

/* 프리셋 간격: gap prop을 인라인 스타일로 주고 싶으면 스타일 바인딩을 써도 되지만,
     간단히 CSS 변수 사용을 권장 */
.cf-logo--sm {
  --cf-logo-gap: 6px;
}
.cf-logo--md {
  --cf-logo-gap: 8px;
}
.cf-logo--lg {
  --cf-logo-gap: 10px;
}

.cf-logo--clickable {
  cursor: pointer;
}
</style>
